export default {
  home: "Home",
  user: {
    list: "Users",
    groups: "Groups",
  },
  about: {
    abouts: "Information",
    editAbout: "Edit Information",
    reviewEditAbout: "Review",
  },
  instruction: {
    instruction: "Instruction",
    instruction_detail: "Instruction Detail",
    edit_instruction: "Edit Instruction",
    review_instruction: "Review",
    add_instruction: "Add Instruction"
  },
  customer: {
    list: "Customers",
    locations: "Locations",
    locationDetail: "Location Detail",
    editLocation: "Edit Location",
    units: "Units",
    devices: "Devices",
    licenses: "Licenses",
    detail: "Customer Detail",
    edit: "Edit Customer",
    addCustomer: "New Customer",
  },
  treatment: {
    treatments: "Treatments",
    requests: "Treatment Requests",
    database: "Treatment Database",
    failure_tracking: "Failure Tracking",
    shipment_certificates: "Shipment Certificates",
    shipment_certificates_report: "Shipment Certificates Report",
    add: "Add Treatment Database",
    edit: "Edit Treatment Database",
    detail: "View Treatment Database",
    monitoring: "Treatment Monitoring",
    monitoring_detail: "Graph Monitoring",
    rpa: "RPA Management",
  },
  treatmentRequest: {
    add: "Add Treatment Request",
    edit: "Edit Treatment Request",
    detail: "Treatment Request Detail",
  },
  failureTracking: {
    add: "Add Failure",
    edit: "Edit Failure",
    detail: "Failure Event Detail",
  },
  content: {
    contents: "Contents",
    mail_list: "Mail List",
    notification_list: "Notification List",
    instructions: "Instructions",
    maintenance_equipment: "Maintenance",
    activity_logs: "Activity Logs",

    license_list: "License List",
    onlineMode: "Online mode",
    web_config: "Web Config",
  },
  maintenance: "Maintenance Reports",
  statistics: "Statistics",
  support: {
    support: "Support",
    info: "Information",
    license: "About Us",
  },
  configs: "Configuration",
  config: {
    mail: "Mail Configuration",
    password: "Password Request",
    notification: "Notification Setting",
  },
  email: {
    list: "Email List"
  },
  variable: {
    breadcumb: "Variables"
  },
  shipment: {
    add: "Add Request",
    edit: "Edit Shipment Certificate",
    detail: "Shipment Certificate Detail",
  },
  license: {
    edit: "Edit About Us",
    review: "Review"
  },
  rpa: {
    add: "Add RPA",
    edit: "Edit RPA",
    view: "RPA Details",
  },
  certificates: {
    shipment_certificate: "Shipment Certificate",
    treatment_certificate: "Treatment Certificate",
    graph_certificate: "Treatment Graph",
  }
};
